'use strict';

var browserHeight = $(window).height(),
    browserWidth = $(window).width(),
    isDevice = false,
    isMobile = false,
    isios = false,
    menuOpen = false,
    totalHeight = 0;

if (browserWidth < 600) {
    isMobile = true;
}

$(document).ready(function () {

    var video = document.getElementById('bgvideo');
    if (video) {
        //video.removeChild(video.firstChild);
        var source1 = document.createElement('source');
        if (source1) {

            if (isMobile) {
                //source1.setAttribute('src', '/images/amcar-test-mobile.mp4');
                source1.setAttribute('src', 'https://player.vimeo.com/external/266451027.hd.mp4?s=c0349544218fdc418b9a3efa8807293fe9729c01&profile_id=174');
            } else {
                //source1.setAttribute('src', '/images/amcar-test.mp4');
                source1.setAttribute('src', 'https://player.vimeo.com/external/266451027.hd.mp4?s=c0349544218fdc418b9a3efa8807293fe9729c01&profile_id=174');
            }

            video.appendChild(source1);
        }
    }

    setTextInfoHeights();
    benefitsIntro();
});

var newtimestamp = Date.now();

function logstuff(message) {
    var temptimestamp = Date.now() - newtimestamp;
}

function setTextInfoHeights() {
    $('.benefit').each(function (index) {
        var temp = Math.round($(this).find('.info').outerHeight());
        //$(this).attr('data-height', temp);
        //$(this).find('.info').css('visibility', 'hidden');
        //$(this).find('.info').css('height', '0px');

        totalHeight = totalHeight + parseInt(temp);
    });
}

$('.benefit').on('click', function () {

    if ($(this).hasClass('visible')) {

        $(this).find('.info').slideUp();

        var tlOpen = new TimelineMax();

        tlOpen.fromTo($(this).find('.info'), 0.5, {
            opacity: 1
        }, {
            opacity: 0
        });

        // tlOpen.fromTo($(this).find('.info'), 0.5, {
        //     css: { height: $(this).attr("data-height") }

        // }, {
        //         css: { height: "0" }
        //     }, "-=0.3");

        tlOpen.fromTo($(this).find('.more'), 0.3, {
            opacity: 0
        }, {
            opacity: 1
        }, "-=0.1");

        $(this).removeClass('visible');
    } else {

        $(this).find('.info').slideDown();

        var anyVisible = false;
        var _tlOpen = new TimelineMax();

        $('.benefit').each(function (index) {
            if ($(this).hasClass('visible')) {
                anyVisible = true;

                _tlOpen.fromTo($(this).find('.info'), 0.3, {
                    opacity: 1
                }, {
                    opacity: 0
                });

                _tlOpen.fromTo($(this).find('.more'), 0.3, {
                    opacity: 0
                }, {
                    opacity: 1
                }, "-=0.1");

                $(this).removeClass('visible');
            }
        });

        _tlOpen.fromTo($(this).find('.more'), 0.3, {
            opacity: 1
        }, {
            opacity: 0
        }, "-=0.1");

        _tlOpen.fromTo($(this).find('.info'), 0.5, {
            opacity: 0
        }, {
            opacity: 1
        }, "-=0.3");

        $(this).find('.info').css('visibility', 'visible');
        $(this).addClass('visible');

        totalHeight = totalHeight + 100;

        $('.marker-line svg').attr('style', 'enable-background: new 0 0 2 ' + totalHeight + ';');
        $('.marker-line svg').attr('viewBox', '0 0 2 ' + totalHeight);

        $('.marker-line svg path').attr('d', 'M1,0v' + totalHeight);
        $('.marker-line svg path').attr('data-length', totalHeight);
        $('.marker-line svg path').attr('stroke-dasharray', totalHeight + ',' + totalHeight);

        $('.marker-line svg path').css('transition', 'stroke-dashoffset 1s ease-out .1s');
    }
});

function benefitsIntro() {

    var tl = new TimelineMax();

    tl.fromTo($('.benefits-container .bg-content'), 1, {
        opacity: 0
    }, {
        opacity: 1
    }, "+=0.4");

    tl.fromTo($('.benefits-container h1'), .8, {
        y: 30,
        opacity: 0
    }, {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut
    });

    tl.fromTo($('.benefits-container .subheading'), .3, {
        y: 30,
        opacity: 0
    }, {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut
    });

    tl.add(animateMarkerLine);

    tl.staggerFromTo($('.benefit'), 0.6, {
        y: 20,
        opacity: 0
    }, {
        y: 0,
        opacity: 1,
        ease: Power4.easeOut,
        onComplete: function onComplete() {
            $($(this)[0].target.children[0].children[0].children).addClass('animate-it');
            $($(this)[0].target.children[0].children[0].children).attr('stroke-dashoffset', '0');
        }
    }, 0.4, "-=0.1");

    tl.fromTo($('.cta-btn'), 0.6, {
        y: 20,
        opacity: 0
    }, {
        y: 0,
        opacity: 1,
        ease: Power2.easeOut

    }, "+=0.1");
}

function animateMarkerLine() {
    $('#markerline path').addClass('animate-it');
    $('#markerline path').attr('stroke-dashoffset', '0');
}